import { defineChain } from 'viem'
import { anvil as viemAnvil } from 'viem/chains'

/**
 * Placeholder public RPC for Robinhood Chain. NOT for production: algoboo services must set
 * `ALGOBOO_RPC_URL` to an operator-provided endpoint.
 */
export const ROBINHOOD_PLACEHOLDER_RPC_URL = 'https://rpc.mainnet.chain.robinhood.com'

export const ROBINHOOD_CHAIN_ID = 4663
export const ANVIL_CHAIN_ID = 31337

function envRpcUrl(): string | undefined {
  const fromEnv = typeof process !== 'undefined' ? process.env['ALGOBOO_RPC_URL'] : undefined
  return fromEnv && fromEnv.length > 0 ? fromEnv : undefined
}

/** Robinhood Chain (Arbitrum Nitro, native ETH). RPC from `ALGOBOO_RPC_URL`, else the placeholder. */
export const robinhoodChain = defineChain({
  id: ROBINHOOD_CHAIN_ID,
  name: 'Robinhood Chain',
  nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
  rpcUrls: {
    default: { http: [envRpcUrl() ?? ROBINHOOD_PLACEHOLDER_RPC_URL] },
  },
  blockExplorers: {
    default: { name: 'Blockscout', url: 'https://robinhoodchain.blockscout.com' },
  },
})

/** Local anvil (31337). */
export const anvil = viemAnvil

export const supportedChains = { [ROBINHOOD_CHAIN_ID]: robinhoodChain, [ANVIL_CHAIN_ID]: anvil } as const

export type SupportedChainId = keyof typeof supportedChains

export function isSupportedChainId(id: number): id is SupportedChainId {
  return id === ROBINHOOD_CHAIN_ID || id === ANVIL_CHAIN_ID
}
